module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-allowance-proposal/bc-ap-attachment/bc-ap-attachment.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-allowance-proposal/bc-ap-attachment/bc-ap-attachment.component.scss
// module chunks = main